<div class="client-wrapper">
  <!-- Mobile header (visible only on mobile) -->
  <div class="client-mobile-header">
    <button class="client-mobile-header__back" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
    </button>
    <span class="client-mobile-header__title">{{ pageTitle() }}</span>
  </div>

  <div class="client-container">
    <app-vertical-tabs></app-vertical-tabs>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
